import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('primaryParamsSection');

    return {
        ALTITUDE_LABEL: t('altitudeLabel'),
        AUTO_OPTIMIZE_LABEL: t('autoOptimizeLabel'),
        AUTO_OPTIMIZE_OFF: t('autoOptimizeOff'),
        AUTO_OPTIMIZE_ON: t('autoOptimizeOn'),
        PATH_ANGLE_LABEL: t('pathAngleLabel'),
        ROUTE_SPACING_LABEL: t('routeSpacingLabel'),
        TURN_TYPE_LABEL: t('turnTypeLabel'),
        TURN_TYPE_RACETRACK: t('turnTypeRacetrack'),
        TURN_TYPE_STRAIGHT: t('turnTypeStraight'),
        TURN_TYPE_U_TURN: t('turnTypeUTurn')
    };
};

export default useTranslation;
